import React from 'react';
import { Play } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';

const HERO_VIDEO = 'https://customer-assets.emergentagent.com/job_3f9e40e3-cca9-4507-83e7-20ced098354a/artifacts/cpb0l77k_1%20OF%203.mp4';

const Hero = () => {
  const navigate = useNavigate();

  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
      data-testid="hero-section"
    >
      {/* Full-bleed looping video background */}
      <video
        className="absolute inset-0 w-full h-full object-cover"
        src={HERO_VIDEO}
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
        aria-hidden="true"
        data-testid="hero-video"
      />

      {/* Subtle dark gradient so copy stays legible over any frame */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/55 pointer-events-none" />

      {/* Smooth fade into the next (white) section */}
      <div className="absolute bottom-0 left-0 right-0 h-28 bg-gradient-to-t from-white to-transparent pointer-events-none" />

      {/* Hero Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h1
          className="text-4xl sm:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight drop-shadow-2xl"
          data-testid="hero-heading"
        >
          Simplifying payments.
          <br />
          Empowering merchants.
        </h1>
        <p
          className="text-lg sm:text-2xl text-white/95 mb-10 sm:mb-12 max-w-4xl mx-auto drop-shadow-lg leading-relaxed"
          data-testid="hero-subheading"
        >
          Flexible, secure payment and acquiring solutions designed to help your business grow — in store, online and everywhere in between.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <Button
            onClick={() => navigate('/contact-sales')}
            size="lg"
            className="bg-white text-[#1F4E79] hover:bg-gray-100 text-base px-7 py-4 transition-all duration-200 shadow-lg hover:shadow-xl"
            data-testid="hero-speak-to-team-btn"
          >
            Speak to Our Team
          </Button>
          <Button
            onClick={() => navigate('/products')}
            variant="outline"
            size="lg"
            className="border border-white text-white bg-white/10 hover:bg-white hover:text-[#1F4E79] text-base px-7 py-4 transition-all duration-200 shadow-lg hover:shadow-xl backdrop-blur-sm"
            data-testid="hero-explore-solutions-btn"
          >
            <Play className="mr-2 h-5 w-5" />
            Explore Solutions
          </Button>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
        <div className="animate-bounce">
          <svg
            className="w-6 h-6 text-white"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            viewBox="0 0 24 24"
            stroke="currentColor"
            aria-hidden="true"
          >
            <path d="M19 14l-7 7m0 0l-7-7m7 7V3"></path>
          </svg>
        </div>
      </div>
    </section>
  );
};

export default Hero;
